import Link from 'next/link'

import { Card } from '@wartek-id/card'
import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'

import { PENGELOLAAN_KINERJA_PS_PATH } from 'app/KinerjaShared/constants/path'
import { useApiGetPendingPerencanaan } from 'api/kinerja/kepala-sekolah/pengawas-sekolah/perencanaan'
import useToggleSdkContext from 'utils/useToogleSdk'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'

import type { FC } from 'react'

type CardPerencanaanPendingProps = {}

const CardPerencanaanPending: FC<CardPerencanaanPendingProps> = ({}) => {
  const { isEnabled, isHavePeriod } = usePeriodContext()

  const toggleValue = useToggleSdkContext()
  const isPerencanaanEnabled =
    toggleValue?.['kinerja-ps-perencanaan-enabled'] || false

  const { isLoading, data } = useApiGetPendingPerencanaan(
    { limit: 1 },
    { enabled: isEnabled && isHavePeriod && isPerencanaanEnabled }
  )

  if (isPerencanaanEnabled && !isLoading && data?.data?.length >= 1)
    return (
      <Card>
        <div className="flex gap-6 px-6 py-4 items-center">
          <div className="flex-1 flex flex-col gap-1 justify-center">
            <div className="flex items-center gap-2">
              <Text variant="heading-md">
                Ada Perencanaan Kepala Sekolah yang belum selesai
              </Text>
            </div>
            <Text color="subdued">
              Sebelum lanjut ke tahap Penilaian, selesaikan tahap Perencanaan
              Kepala Sekolah terlebih dahulu.
            </Text>
          </div>

          <div className="px-6">
            <Link href={`${PENGELOLAAN_KINERJA_PS_PATH}/perencanaan`} passHref>
              <Button as="a" size="md" color="white" className="w-60">
                Ke Perencanaan <Icon color="inherit">chevron_right</Icon>
              </Button>
            </Link>
          </div>
        </div>
      </Card>
    )

  return null
}
export default CardPerencanaanPending
